// Tools and Metrics — a placeholder page composed entirely of admin-authored
// Visual Editor sections. Empty until an admin adds content in the admin
// dashboard. Hidden from non-admins when the page-visibility toggle is off.
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { usePageVisibility } from "@/lib/pageVisibility";
import PageSections from "@/components/PageSections";

export default function ToolsAndMetrics() {
  const { user } = useAuth();
  const vis = usePageVisibility();
  const isAdmin = user?.role === "admin";
  const hidden = vis.tools_and_metrics === false;
  const [sections, setSections] = useState(null);

  useEffect(() => {
    api.get("/site-settings/page-sections/tools_and_metrics")
       .then(r => setSections(r.data.sections || []))
       .catch(() => setSections([]));
  }, []);

  if (hidden && !isAdmin) return <Navigate to="/" replace />;

  const isEmpty = Array.isArray(sections) && sections.filter(s => !s.hidden).length === 0;

  return (
    <div data-testid="tools-and-metrics-page" className="max-w-5xl mx-auto px-6 md:px-10 py-12">
      {hidden && isAdmin && (
        <div data-testid="tools-and-metrics-hidden-banner"
             className="mb-6 text-xs uppercase tracking-[0.24em] px-3 py-2 rounded-md border border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-800/60 dark:bg-amber-950/40 dark:text-amber-200">
          Hidden from public — visible only to admins. Toggle visibility in Admin → Site &amp; Editors → Page visibility.
        </div>
      )}
      <PageSections pageKey="tools_and_metrics" />
      {isAdmin && isEmpty && (
        <div data-testid="tools-and-metrics-empty-state"
             className="mt-2 border-2 border-dashed border-slate-300 rounded-lg p-10 text-center text-slate-500 dark:border-slate-700 dark:text-slate-400">
          <div className="text-xs uppercase tracking-[0.24em] text-slate-400 dark:text-slate-500 mb-2">Placeholder</div>
          <div className="text-slate-700 dark:text-slate-100 font-heading text-xl mb-1">Tools and Metrics</div>
          <p className="text-sm">This page is empty. Open Admin → Site &amp; Editors → Tools and Metrics visual editor to compose content.</p>
        </div>
      )}
      {!isAdmin && isEmpty && (
        <div className="text-center text-slate-500 py-16">
          <div className="text-xs uppercase tracking-[0.24em] text-slate-400 mb-2">Tools and Metrics</div>
          <p className="text-sm">Coming soon.</p>
        </div>
      )}
    </div>
  );
}
